import { NotificationManager } from 'react-notifications';
import _ from 'lodash'
import { Actions as COMPANYACTIONS } from "../../../../store/actions/companyActions";
import axios from 'axios';

import apiURL from'../../../../store/actions/apiURL';

const Types = {
    VIFTO_CONNECTED: "VIFTO_CONNECTED",
    VIFTO_SAVING: "VIFTO_SAVING",
};

const setViftoConnected = (response) => ({
    type: Types.VIFTO_CONNECTED,
    response,
});

const setViftoSaving = (status) => ({
    type: Types.VIFTO_SAVING,
    status,
});

const getViftoExpenseSettings = () => {
    return (dispatch, getState) => {
        // fetch(`http://localhost:3001/integrations/vifto/get-expenses`, {
        fetch(`${apiURL}/integrations/vifto/expenses`, {
            credentials: 'include',
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        })
            .then((res) => res.json())
            .then((data) => {
                dispatch(setViftoConnected({
                    expenseOptions: data.expenseOptions,
                    taxNames: data.taxNames,
                }))
            })
    }
}

const viftoConnect = (email, password) => {
    return (dispatch, getState) => {
        // fetch(`http://localhost:3001/integrations/vifto/connect`, {
        fetch(`${apiURL}/integrations/vifto/connect`, {
            credentials: 'include',
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email, password }),
        }).then(res => res.json())
            .then(data => {
                if (!data.success) {
                    NotificationManager.error('Incorrect email and/or password', 'Vifto Login Failed');
                    return
                }
                dispatch(setViftoConnected({ settings: { tenants: data.organisations } }));

            });
    }
}

const disconnectVifto = () => {
    return (dispatch, getState) => {
        axios({
            method: 'POST',
            url: `${apiURL}/integrations/vifto/revoke`,
            withCredentials: true,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        })
            .then(() => {
                dispatch(COMPANYACTIONS.getCompanySettings())
            })
            .catch((error) => {
                console.error(error)
                NotificationManager.error('Error Disconnecting Vifto', 'Disconnect Vifto')
            })
    }
}


const updateViftoTenant = (tenant) => {
    return (dispatch, getState) => {
        dispatch(setViftoSaving(true));
        // fetch(`http://localhost:3001/integrations/vifto/update-tenant`, {
        fetch(`${apiURL}/integrations/vifto/tenant`, {
            credentials: 'include',
            method: 'POST',
            body: JSON.stringify({ tenant }),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        }).then((res) => res.json())
            .then((data) => {
                dispatch(setViftoConnected({
                    tenant: data.tenant
                }))
                dispatch(getViftoExpenseSettings());
                NotificationManager.success('Vifto Settings Saved Successfully', 'Saving Vifto Settings');
                dispatch(setViftoSaving(false));
            })
            .catch((error) => {
                console.error(error)
                NotificationManager.error('Error Saving Vifto Settings', 'Saving Vifto Settings');
                dispatch(setViftoSaving(false));
            })
    }
}

const updateViftoDetails = (expenseSettings) => {
    return (dispatch, getState) => {

        dispatch(setViftoSaving(true));

        // fetch(`http://localhost:3001/integrations/vifto/update-settings`, {
        fetch(`${apiURL}/integrations/Vifto/update-settings`, {
            credentials: 'include',
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ expenseSettings }),
        })
            .then((res) => res.json())
            .then((data) => {
                dispatch(setViftoSaving(false));
                NotificationManager.success('Vifto Settings Saved Successfully', 'Saving Vifto Settings');
            })
            .catch((error) => {
                dispatch(setViftoSaving(false));
                console.error(error)
                NotificationManager.error('Error Saving Vifto Settings', 'Saving Vifto Settings');
            })
    }
}

const sendPayPeriodToVifto = (payPeriodId) => {
    return (dispatch, getState) => {
        // fetch(`http://localhost:3001/integrations/vifto/payrun`, {
        fetch(`${apiURL}/integrations/vifto/payrun`, {
            credentials: 'include',
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ payPeriodId }),
        }).then((res) => res.json())
            .then((data) => {
                dispatch(setViftoSaving(false));
                if (data.success) {
                    NotificationManager.success('Data Successfully Sent To Vifto', 'Vifto Integration');
                }
            })
            .catch(error => {
                console.error(error)
                if (error.error) {
                    NotificationManager.error(error.error, 'Vifto Integration');
                    return
                }
                NotificationManager.error('Error Sending Data To Vifto', 'Vifto Integration');
            })
    }
}

const Actions = {
    viftoConnect,
    updateViftoTenant,
    updateViftoDetails,
    sendPayPeriodToVifto,
    getViftoExpenseSettings,
    disconnectVifto
}

export { Types, Actions }